// Human labels for cr_phase — the CR processor's resolution bucket
// (lib/centralized-request/cr-db.js markRowResolved). Shared by TripDetail's
// "Why this trip ended where it did" panel and the Trip Requests row view
// (2026-07-12: 745 phase3_close CRs carried a close reason in
// trip_request_source.hold_reason that the UI never showed anywhere).
export const CR_PHASE_LABELS = {
  no_options: 'Closed — no viable options / gate declined',
  held:       'Held for review',
  resolved:   'Resolved (declined/sent/cleared by ops)',  // markTripResolved reset a former 'held' CR trip
};
